export const documentProperties: { [key: string]: string } = {
  author: 'author',
  ESC_EYEYAUTHORSEMAIL: 'authorEmail',
  ESC_CREATEDDATE: 'createdDate',
  date: 'date',
  title: 'title',
  Rank: 'rank',
  Path: 'url',
  ESC_EYCONTENTTYPE : 'eyContentType',
  contentType: 'contentType',
  EYCategory: 'category',
  ESC_SERVICELINEFUNCTION: 'service_line',
  ESC_SECTOR: 'sector',
  ESC_GEOGRAPHICAPPLICABILITY: 'geography',
  excerpt: 'description',
  ESC_EYKCONTENT1: 'content1',
  ESC_EYKCONTENT2: 'content2',
  ESC_EYKCONTENT3: 'content3',
  ESC_EYKCONTENT4: 'content4',
  ESC_EYDocumentID: 'documentId',
  ESC_FileExtension: 'fileExtension',
  escbase_fileextension: 'fileType',
  ESC_EYKSOLUTIONTYPE: 'solutionType',
  ESC_EYMAJORPUBDATE: 'major_public_date',
  vertical: 'vertical',
  confidentialityLevel: 'confidentialityLevel',
  ESC_EYKSTUBRECORDTYPE: 'stubRecordType',
  contentAge: 'contentAge',
  contact: 'contact',
  sortDate: 'sortDate',
  EYKIsEndorsed: 'isEndorsed',
  escbasecrawlurl: 'spworksURL',
  abstract: 'abstract',
  content1: 'content1',
  parentpolicycontent: 'parentpolicycontent',
  ESC_EYAEMID: 'ESC_EYAEMID',
  ESC_EYISSUES: 'ESC_EYISSUES',
  ESC_ATTACHMENTS: 'attachment',
  Size: 'Size',
  MimeType: 'MimeType',
  eyapproach: 'eyapproach',
  serviceoffered: 'serviceoffered',
  clientissues: 'clientissues',
  solutionoverview: 'solutionoverview',
  solutionclientissues: 'solutionclientissues',
  solutionbenefits: 'solutionbenefits',
  bodycontentsection: 'bodycontentsection',
  morebodycontent1: 'morebodycontent1',
  morebodycontent2: 'morebodycontent2',
  morebodycontent3: 'morebodycontent3',
  morebodycontent4: 'morebodycontent4',
  morebodycontent5: 'morebodycontent5',
  subtitledescription: 'subtitledescription',
  policydescription: 'policydescription',
  policycontent: 'policycontent',
  yourresponsibility: 'yourresponsibility',
  eydescription: 'eyDescription',
  policyguidence: 'policyguidence',
  ESC_OVERVIEW: 'overview',
  teamactivity: 'teamactivity',
  ESC_ENTERPRISEKEYWORDS: 'enterpriseKeywords',
  eyTargetUrl: 'eyTargetUrl',
  eyAccess: 'eyAccess',
  ESC_EYBUYER: 'ESC_EYBUYER',
  ESC_EYKSOLUTIONALLIANCES: 'ESC_EYKSOLUTIONALLIANCES',
  ESC_SOLUTIONLEADERS: 'solutionLeaders',
  ESC_SOLUTIONLEADERSEMAIL: 'solutionLeadersEmail',
  ESC_EYCONTACT: 'eyContact',
  ESC_EYCONTACTEMAIL: 'eyContactEmail',
  ESC_ACTIVATION: 'activation',
  ESC_ACCORDIONPILLAR: 'accordionPillar',
  ESC_LASTREVIEWEDDATE: 'lastReviewedDate',
  ESC_REVIEWTYPE: 'reviewType'
};
export { documentProperties as DocumentViewModel };
